import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12v-9l4.912 1.914a1.7 1.7 0 0 1 .428 2.925l-5.34 4.161","key":"svg-0"}],["path",{"d":"M14.044 14.624l-2.044 -2.624h4","key":"svg-1"}],["path",{"d":"M12 12h-9l1.914 -4.912a1.7 1.7 0 0 1 2.925 -.428l4.161 5.34","key":"svg-2"}],["path",{"d":"M12 12v9l-4.912 -1.914a1.7 1.7 0 0 1 -.428 -2.925l5.34 -4.161","key":"svg-3"}],["path",{"d":"M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2","key":"svg-4"}]]

const IconCarFan2 = createReactComponent('outline', 'car-fan-2', 'CarFan2', __iconNode);

export default IconCarFan2;